module.exports = __webpack_public_path__ + "static/media/vtex33.2b2a86c9.png";